export const mapPublicLegendContent =
  "<div class='legend-title'>" +
  "Stesen" +
  "</div>" +
  "<div class='legend-item'>" +
  "<img class='legend-icon' " +
  "src='/assets/map/gear_green.png' " +
  "alt={`Station Normal`}/>" +
  "<span>" +
  "Normal" +
  "</span></div>" +
  "<div class='legend-item'>" +
  "<img class='legend-icon' " +
  "src='/assets/map/gear_orange.png' " +
  "alt={`Station Warning`}/>" +
  "<span>" +
  "Amaran" +
  "</span></div>" +
  "<div class='legend-item'>" +
  "<img class='legend-icon' " +
  "src='/assets/map/gear.png' " +
  "alt={`Station Critical`}/>" +
  "<span>Kritikal" +
  "</span></div>";

export const mapStationContent = (language) => {
  return (
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/gear_green.png' " +
    "alt={`Station`}/>" +
    "<span>" +
    (language === "en" ? "Station" : "Stesen") +
    "</span></div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/water-drop_blue.png' " +
    "alt={`Outlet`}/>" +
    "<span>" +
    (language === "en" ? "Source Point" : "Titik Sumber") +
    "</span></div>"
  );
};

export const mapOverviewContent = (language) => {
  return (
    "<div class='legend-title'>" +
    (language === "en" ? "Station" : "Stesen") +
    "</div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/gear_green.png' " +
    "alt={`Station Normal`}/>" +
    "<span>" +
    (language === "en" ? "Normal" : "Normal") +
    "</span></div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/gear_orange.png' " +
    "alt={`Station Warning`}/>" +
    "<span>" +
    (language === "en" ? "Warning" : "Amaran") +
    "</span></div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/gear.png' " +
    "alt={`Station Critical`}/>" +
    "<span>" +
    (language === "en" ? "Critical" : "Kritikal") +
    "</span></div>" +
    "<div class='legend-title' style='padding-top: 8px'>" +
    (language === "en" ? "Source Point" : "Titik Sumber") +
    "</div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/water-drop_green.png' " +
    "alt={`Outlet Normal`}/>" +
    "<span>" +
    (language === "en" ? "Normal" : "Normal") +
    "</span></div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/water-drop_orange.png' " +
    "alt={`Outlet Warning`}/>" +
    "<span>" +
    (language === "en" ? "Warning" : "Amaran") +
    "</span></div>" +
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/water-drop.png' " +
    "alt={`Outlet Critical`}/>" +
    "<span>" +
    (language === "en" ? "Critical" : "Kritikal") +
    "</span></div>"
  );
};

export const mapInSituContent = (language) => {
  return (
    "<div class='legend-item'>" +
    "<img class='legend-icon' " +
    "src='/assets/map/water-drop_blue.png' " +
    "alt={`In-Situ Location`}/>" +
    "<span>" +
    (language === "en"
      ? "In-Situ Sampling Location"
      : "Lokasi Pensampelan In-Situ") +
    "</span></div>"
  );
};
